import { SELECT_MODELE, COLOR_SQUARE, CLEAR_SQUARES } from "../actions";

const sameSquare = (s1, s2) => {
    if (s1[0] === s2[0] && s1[1] === s2[1]) {
        return true;
    }
    return false;
};

const initialState = [];

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case COLOR_SQUARE:
            const squareExist = state.findIndex(square => {
                return sameSquare(square, payload);
            });
            if (squareExist !== -1) {
                return [
                    ...state.slice(0, squareExist),
                    payload,
                    ...state.slice(squareExist + 1),
                ];
            }
            return [...state, payload];

        case CLEAR_SQUARES:
        case SELECT_MODELE:
            return initialState;

        default:
            return state;
    }
};
